export interface CostBreakdownProductFieldPaths {
  baseFieldPath: string
  bareCostPerUom: string
  bareCostPerMetricUom: string
  totalBareCost: string
  pricePerUom: string
  pricePerMetricUom: string
  insurance: string
  tariffs: string
  atypicalSurcharges: string
  isCompleted: string
  allocatedGrCostPercentage: string
  allocatedGrCostAmount: string
  allocatedGrCostPerUom: string
  lastLaidDownCostPerUom: string
  totalLaidDownCostPerUom: string
  freightAndMiscCostPerUom: string
  duties: {
    amount: string
    percentage: string
  }
  mpf: {
    amount: string
    percentage: string
  }
  hmf: {
    amount: string
    percentage: string
  }
}

export const getCostBreakdownProductFieldPaths = (productIndex: number): CostBreakdownProductFieldPaths => {
  const baseFieldPath = `products.${productIndex}` as const

  return {
    baseFieldPath,
    bareCostPerUom: `${baseFieldPath}.bareCostPerUom` as const,
    bareCostPerMetricUom: `${baseFieldPath}.bareCostPerMetricUom` as const,
    totalBareCost: `${baseFieldPath}.totalBareCost` as const,
    pricePerUom: `${baseFieldPath}.pricePerUom` as const,
    pricePerMetricUom: `${baseFieldPath}.pricePerMetricUom` as const,
    insurance: `${baseFieldPath}.insurance` as const,
    tariffs: `${baseFieldPath}.tariffs` as const,
    atypicalSurcharges: `${baseFieldPath}.atypicalSurcharges` as const,
    isCompleted: `${baseFieldPath}.isCompleted` as const,
    allocatedGrCostPercentage: `${baseFieldPath}.allocatedGrCostPercentage` as const,
    allocatedGrCostAmount: `${baseFieldPath}.allocatedGrCostAmount` as const,
    allocatedGrCostPerUom: `${baseFieldPath}.allocatedGrCostPerUom` as const,
    lastLaidDownCostPerUom: `${baseFieldPath}.lastLaidDownCostPerUom` as const,
    totalLaidDownCostPerUom: `${baseFieldPath}.totalLaidDownCostPerUom` as const,
    freightAndMiscCostPerUom: `${baseFieldPath}.freightAndMiscCostPerUom` as const,
    duties: {
      amount: `${baseFieldPath}.duties.amount` as const,
      percentage: `${baseFieldPath}.duties.percentage` as const,
    },
    mpf: {
      amount: `${baseFieldPath}.mpf.amount` as const,
      percentage: `${baseFieldPath}.mpf.percentage` as const,
    },
    hmf: {
      amount: `${baseFieldPath}.hmf.amount` as const,
      percentage: `${baseFieldPath}.hmf.percentage` as const,
    },
  }
}
